/** Metadata sections to attach to a report, keyed by section name. */
export type CrashReportDetails = { readonly [section: string]: unknown };
/** Report fields to overwrite. */
export type CrashReportOverrides = { readonly context?: string; readonly groupingHash?: string };
export type BreadcrumbMetadata = { readonly [key: string]: unknown };
export type BreadcrumbType = 'error' | 'log' | 'manual' | 'navigation' | 'process' | 'request' | 'state' | 'user';

export interface CrashReporter {
  /** `error` is whatever was caught; implementations must hand it to the reporter unchanged. */
  reportError: (error: unknown, customDetails?: CrashReportDetails, reportOverrides?: CrashReportOverrides) => void;
  addBreadcrumb: (name: string, metadata?: BreadcrumbMetadata, type?: BreadcrumbType) => void;
}

// TODO: replace console.error with logger
let reportErrorInterface: CrashReporter['reportError'] = () =>
  // biome-ignore lint/suspicious/noConsole: fallback until crashReporterInterfaceInit runs
  console.warn('initialize global reportErrorInterface with crashReporterInterfaceInit first...');
let addBreadcrumbInterface: CrashReporter['addBreadcrumb'] = () => {};

export const crashReporterInterfaceInit = ({ reportError, addBreadcrumb }: Partial<CrashReporter>): void => {
  reportErrorInterface = reportError || reportErrorInterface;
  addBreadcrumbInterface = addBreadcrumb || addBreadcrumbInterface;
};

export const reportError: CrashReporter['reportError'] = (error, customDetails, reportOverrides) =>
  reportErrorInterface(error, customDetails, reportOverrides);
export const addBreadcrumb: CrashReporter['addBreadcrumb'] = (name, metadata, type) =>
  addBreadcrumbInterface(name, metadata, type);
